import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, iif, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BreakpointService } from './breakpoint.service';
const blockIOs = {
    usePosition: true,
    useTouchMove: true,
    overscrollBehavior: true,
    useTouchAction: true,
    useOverflow: true,
    useMaxHeight: true
};
const DOCUMENT_SCROLL_FREEZE_BEHAVIUOR = {
    default: {
        useOverflow: true,
    },

    iPad: blockIOs,
    iPhone: blockIOs,
    iPod: blockIOs,
    'iPad Simulator': blockIOs,
    'iPhone Simulator': blockIOs,
    'iPod Simulator': blockIOs,
};
@Injectable({
    providedIn: 'root'
})
export class FreezeScrollOnDocumentService extends OnDestroyMixin {
    private scrollingElement: Element;
    private body: HTMLElement;
    private html: HTMLElement;
    private renderer: Renderer2;
    private scrollTop: number;
    private _freeze: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    behaviuor: any;
    position: number;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private rendererFactory: RendererFactory2,
        private breakpointService: BreakpointService
    ) {
        super();
        this.body = this.document.body;
        this.html = this.document.body.parentElement;
        this.setBehaviuor();
        this.prepRender();
        this.setPageElements();
        this.heightSubscription();
    }
    private heightSubscription() {
        if (this.behaviuor.useMaxHeight) {
            this._freeze
                .pipe(untilComponentDestroyed(this),
                    switchMap(_ => iif(() => _, this.breakpointService.orientation$, of(''))))
                .subscribe(orientation => {
                    if (orientation.includes('portrait')) {
                        this.setStyle('height', '100vh');
                        this.setStyle('max-height', '100vh');
                    } else if (orientation.includes('landscape')) {
                        this.setStyle('height', '100%');
                        this.setStyle('max-height', '100%');
                    } else {
                        this.removeStyle('max-height');
                        this.removeStyle('height');
                    }
                });
        }
    }

    freezeDocument() {

        this.scrollTop = this.scrollingElement.scrollTop;
        this._freeze.next(true);
        this.freeze();
    }

    unfreezeDocument() {

        this._freeze.next(false);
        this.thaw();
        setTimeout(() => this.scrollingElement.scrollTop = this.scrollTop, 112);
    }

    private setBehaviuor() {
        this.behaviuor = {
            useOverflow: true,
        }
        // DOCUMENT_SCROLL_FREEZE_BEHAVIUOR[this.platform] || DOCUMENT_SCROLL_FREEZE_BEHAVIUOR[this.browser] || DOCUMENT_SCROLL_FREEZE_BEHAVIUOR.default;
    }

    private setPageElements() {
        this.body =  this.document.body;
        this.html =  this.document.body.parentElement;
        this.scrollingElement = this.document.scrollingElement || this.document.body;
    }

    private prepRender() {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    private freeze() {
        if (this.behaviuor.usePosition) {
            this.position = window.pageYOffset;
            this.renderer.setStyle(this.body, 'position', 'fixed');
            this.renderer.setStyle(this.body, 'top', `-${this.position}px`);
        }
        if (this.behaviuor.useOverflow) {
            this.setStyle('overflow-y', 'hidden');
        }
        if (this.behaviuor.overscrollBehavior) {
            this.setStyle('overscroll-behavior', 'none');
        }
        if (this.behaviuor.useTouchAction) {
            this.setStyle('touch-action', 'none');
        }
        if (this.behaviuor.useTouchMove) {
            this.body.addEventListener('onTouchMove', this.preventEvent, false);
            this.html.addEventListener('onTouchMove', this.preventEvent, false);
        }
    }

    private thaw() {
        if (this.behaviuor.usePosition) {
            this.renderer.removeStyle(this.body, 'position');
            this.renderer.removeStyle(this.body, 'top');
            window.scrollTo(0, this.position);
        }

        if (this.behaviuor.useOverflow) {
            this.removeStyle('overflow-y');
        }
        if (this.behaviuor.overscrollBehavior) {
            this.removeStyle('overscroll-behavior');
        }
        if (this.behaviuor.useTouchAction) {
            this.removeStyle('touch-action');
        }
        if (this.behaviuor.useTouchMove) {
            this.body.removeEventListener('onTouchMove', this.preventEvent, false);
            this.html.removeEventListener('onTouchMove', this.preventEvent, false);
        }
    }

    private preventEvent(e: Event) {
        e.preventDefault();
    }

    private setStyle(style: string, value: string) {
        this.renderer.setStyle(this.body, style, value);
        this.renderer.setStyle(this.html, style, value);
    }

    private removeStyle(style: string) {
        this.renderer.removeStyle(this.body, style);
        this.renderer.removeStyle(this.html, style);
    }

}
